import React from 'react'
import { useNavigate } from 'react-router-dom'

import './Containers.css'

export default function ToolContainer (props) {
    const navigate = useNavigate()

    const configHandler = () => {
        if (props.isDisabled) return
        navigate(`/configurations/${props.toolName}`)
    }

    return (
        <div className='x_card-container'>
        <div className={`x_card card border-primary ${ props.isDisabled ? 'x_card-disabled' : '' }`}>
            <div className='x_card-header card-header'>
            {props.title || 'Empty'}
            {!props.noConfig && (
                <i onClick={configHandler} className='fa-solid fa-gear x_config-button' />
            )}
            </div>
            {props.children}
        </div>

        {props.isDisabled && (
            <div className='x_card-overlay'><span>Deprecated</span></div>
        )}
        </div>
    )
}